import { AfterViewInit, Component, HostListener, Injector, OnInit } from '@angular/core';
import { RouteUtil } from "../../../util/route.util";
import { BaseComponent } from "../../base.component";
import { SHARED_IMPORTS } from '../../../util/shared-imports';
import { SnackBarUtil } from '../../../util/snack.bar.util';
import { PlatformService } from '../../../util/service/platform.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [
    ...SHARED_IMPORTS,
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent extends BaseComponent implements OnInit, AfterViewInit {
  fullImage?: any;
  supportNumbers: string[] = [];
  showButton = false;
  rules: any;

  constructor(
    injector: Injector,
    private platformService: PlatformService
  ) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();

    this.getSupportNumber();
    this.getRules();
  }

  override async ngAfterViewInit() {
    if (this.platformService.isServer()) return;

    const { default: Swiper } = await import('swiper');
    const { Navigation, Autoplay } = await import('swiper/modules');
    
    new Swiper('.swiper', {
      modules: [Navigation, Autoplay],
      slidesPerView: 4,
      spaceBetween: 10,
      loop: true,
      autoplay: {
        delay: 1000, // هر ۳ ثانیه
        disableOnInteraction: false, // با لمس یا کلیک متوقف نشود
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  getSupportNumber() {
    this.serviceApi.getPublicConfig('SUPPORT_PHONE_NUMBER').subscribe((res) => {
      if (!res) {
        SnackBarUtil.makeMessageWithAction(this, this.strings.problem_on_connecting_to_server, this.strings.retry, () => {
          this.loadOnline();
        });
        return;
      }

      if (res.data) {
        // رشته رو جدا کن به آرایه بر اساس فاصله
        this.supportNumbers = res.data
        .replace(/[-\n\r]/g, ' ')   // حذف - و خط جدید
        .trim()
        .split(/\s+/); // ["02165013024", "02165013095", "09105698040"]
      } else {
        SnackBarUtil.makeMessage(this, res.error!);
      }
    })
  }

  showFullImage(imageUrl: string, event: Event) {
    event.preventDefault();
    this.fullImage = imageUrl;
  }

  openBazarLink() {
    window.open('http://cafebazaar.ir/app/?id=com.baazarplus.app&ref=share', '_blank');
  }

  openGooglePlayLink() {
    window.open('https://cafebazaar.ir/app/com.aminsft.baazar2', '_blank');
  }

  openMayketLink() {
    window.open('https://myket.ir/app/com.baazarplus.app', '_blank');
  }

  openAparatLink() {
    window.open('https://www.aparat.com/baazar97', '_blank');
  }

  openBaleLink() {
    window.open('https://ble.ir/baazargold', '_blank');
  }

  openTelegramLink() {
    window.open('https://t.me/baazar_tala', '_blank');
  }

  openInstagramLink() {
    window.open('https://www.instagram.com/baazarofficial/', '_blank');
  }

  goToContactUs() {
    this.router.navigate([RouteUtil.CONTACT_US]).then(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (this.platformService.isServer()) return;
    this.showButton = window.scrollY > 200;
  }

  scrollToTop() {
    if (this.platformService.isServer()) return;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  goToRules() {
    this.router.navigate([RouteUtil.RULES]).then(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  onRulesClicked() {
    this.router.navigate([RouteUtil.RULES]).then(() => {
      const outletContainer = document.getElementById('outlet-container');
      if (outletContainer) {
        outletContainer.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    });
  }

  getRules() {
    if (this.platformService.isServer()) return;
    
    this.serviceApi.getRules().subscribe((res) => {
      if (!res) {
        SnackBarUtil.makeMessageWithAction(this, this.strings.problem_on_connecting_to_server, this.strings.retry, () => {
          this.loadOnline();
        });
        return;
      }
  
      if (res.data) {
        this.rules = res.data;
      } else {
        SnackBarUtil.makeMessage(this, res.error!);
      }
    })
  }
}
